'use strict';

import Axios from 'axios';
import { parseResponse, handleError } from '@/_helpers/utils.js';

export default {
  fetch(vacancyId) {
    return Axios.get(`/1.0/vacancies/${vacancyId}/email-templates`)
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err);
      })
  },

  save({ vacancyId, templates }) {
    const key = 'template_text';

    templates = templates.map(el => {
      if (el[key]) {
        return {
          ...el,
          // Заменяем пустой параграф на br, чтобы при рендере html в письме количество пропущенных строк совпадло с редактором
          [key]: el[key].replaceAll('<p style="margin: 0; padding-top: 0; padding-bottom: 0; "></p>', '<br>')
        };
      }
      return el;
    });

    return Axios.put(`/1.0/vacancies/${vacancyId}/email-templates`, { templates })
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err);
      });
  }
};
